<script setup lang="ts">
import AppKbd from '../AppKbd/AppKbd.vue'
import type { KbdTone } from '../AppKbd/kbd-types'
import { useShortcutLabel } from '../../../composables/useKeyboardShortcut'
import type { KeyboardShortcut } from '../../../lib/keyboard-shortcut'

const props = withDefaults(
  defineProps<{
    /** The chord this key cap displays, localised to the viewer's platform. */
    shortcut: KeyboardShortcut
    /** Visual weight: `neutral` (default, on an ordinary surface) · `on-accent` (on a filled accent key). */
    tone?: KbdTone
  }>(),
  {
    tone: 'neutral',
  },
)

const label = useShortcutLabel(() => props.shortcut)
</script>

<template>
  <AppKbd :tone="tone">{{ label }}</AppKbd>
</template>
